import BaseRepository from 'Domain/Repositories/BaseRepository/BaseRepository';
import { Invoice }   from 'Domain/Models';

const config = {
    model: Invoice,
    baseRoute: '/admin/invoice',
    singular: 'invoice',
    plural: 'invoices',
}

class InvoiceRepository extends BaseRepository<Invoice, typeof config.singular, typeof config.plural> {

  sendInvoicePdf(id: number) {
    return this.makeRequest({
      path: `${this.baseRoute}/${id}/send-invoice-pdf`,
      type: 'POST',
      callback: () => true,
    });
  }

  sendTicketsFromInvoice(id: number) {
    return this.makeRequest({
      path: `${this.baseRoute}/${id}/send-tickets`,
      type: 'POST',
      callback: () => true,
    });
  }

  downloadInvoicePdf(id: number) {
    return this.makeRequest({
      path: `${this.baseRoute}/${id}/download-invoice-pdf`,
      type: 'GET',
      callback: this.downloadFile('application/pdf'),
    });
  }


}

export default new InvoiceRepository(config);
